/* eslint-disable camelcase */

export default api => {
  function searchDisputeAsnRtv(query) {
    return api.get(`/_svc/slapi-v1/documents/eligible${query}`);
  }
  function listDisputes(query) {
    return api.get(`/_svc/slapi-v1/disputes/list?${query}`);
  }
  function listDisputeReasons(query) {
    return api.get(`/_svc/slapi-v1/disputes/reasons${query}`);
  }
  function createDispute(payload) {
    return api.post(`/_svc/slapi-v1/disputes/create`, payload);
  }

  return {
    searchDisputeAsnRtv,
    createDispute,
    listDisputes,
    listDisputeReasons
  };
};



// WEBPACK FOOTER //
// ./src/services/DisputesService.js